import React, { Component, useEffect } from "react";
import { BrowserRouter, Route, Routes as RouterRoutes, useLocation } from "react-router-dom";

import UnverifiedMailRoute from './utility/UnverifiedMailRoute';
import PrivateRoute from './utility/PrivateRoute';
import PublicRoute from './utility/PublicRoute';
import ModernHome from "./components/Home";
import About from "./components/About";
import PromotionTool from "./components/PromotionTool";
import News from "./components/News";
import Certification from "./components/Certification";

import Faq from "./components/Faq";
import Term from "./components/Term";
import Social from "./components/Social";
import Salary from "./components/Salary";
import Agent from "./components/Agent";
import Map from "./components/Map";
import Swap from "./components/Swap";
import Bonus from "./components/Bonus";
import Bank from "./components/Bank";
import Wallet from "./components/Wallet";
import ChangePin from "./components/ChangePin";
import Phone from "./components/Phone";
import GoogleAuth from "./components/GoogleAuth";
import RefLink from "./components/RefLink";

import ReinvestBonus from "./components/ReinvestBonus";

import FX from "./components/FX";


import AllPages from "./components/AllPages";
import BillPay from "./components/BillPay";
import Blog from "./components/Blog";
import BlogDetails from "./components/BlogDetails";
import Carts from "./components/Carts";
import Components from "./components/Components";
import ComponentsAccordion from "./components/ComponentsAccordion";
import ComponentsAlerts from "./components/ComponentsAlerts";
import ComponentsButtons from "./components/ComponentsButtons";
import ComponentsModals from "./components/ComponentsModals";
import ComponentsNotifications from "./components/ComponentsNotifications";
import ComponentsProgress from "./components/ComponentsProgress";
import ComponentsTabs from "./components/ComponentsTabs";
// import ComponentsTooltip from "./components/ComponentsTooltip";
import Contact from "./components/Contact";
import Notification from "./components/Notification";
import Saving from "./components/Saving";
import Signin from "./components/Signin";
import Signup from "./components/Signup";
import VerifyEmail from './components/VerifyEmail';
import ForgetPassword from './components/ForgetPassword';


import Transaction from "./components/Transaction";
import TransactionDetails from "./components/TransactionDetails";
import Mine from "./components/Mine";
import PersonalInformation from "./components/PersonalInformation";

import Bot from "./components/Bot";

import Trade from "./components/Trade";
import Transcript from "./components/Transcript";

// import TradeBots from "./components/Trade/TradeBots";

import Asset from "./components/Asset";
import P2P from "./components/P2P";
import AllP2P from "./components/AllP2P";
import Chats from "./components/Chats";
import KYC from "./components/KYC";
import AllKYC from "./components/KYC/AllKYC";
import ChangePassword from "./components/ChangePassword";


import Testimony from "./components/Testimony";


// import TradeHistory from "./components/Trade-history";
import Referrals from "./components/Referrals";
import TeamEarning from "./components/TeamEarning";
// import Security from "./components/Security";


// import DepositHistory from "./components/Deposits/History";
import Deposit from "./components/Deposits/New";

import Withdraw from "./components/Withdraw/New";

import Transfer from "./components/Transfer/New";


// import WithdrawalHistory from "./components/Withdrawals/History";
// import Withdraw from "./components/Withdrawals/New";


import DepositHistory from "./components/Deposit-history";
import WithdrawalHistory from "./components/Withdrawal-history";
import TransferHistory from "./components/Transfer-history";


import UserVerification from "./components/UserVerification";
import NotFound from "./components/NotFound";
import WithdrawalInfo from "./components/WithdrawalInfo";
import { useSelector, useDispatch } from 'react-redux';
import { authActions } from './redux/actions';
import { userSelect, allRemoteSettingsSelect } from './redux/selectors/index';
import Lottie from 'lottie-react';
import chattyLottie from './assets/lottie/chatty.json';





function AppRoutes() {


    const dispatch = useDispatch();
    const userData = useSelector(userSelect);
    const [loading, setLoading] = React.useState(true);
    // const { pathname } = useLocation();

    useEffect(() => {
        dispatch(authActions.onRefreshSystemData("system/refresh", 10, {}, response => {
            setLoading(false)
        }))
    }, [userData?.email])




    // // Setting page scroll to 0 when changing the route
    // useEffect(() => {
    //     document.documentElement.scrollTop = 0;
    //     document.scrollingElement.scrollTop = 0;
    // }, [pathname]);

    return (<>


        {!loading && <BrowserRouter>
            <RouterRoutes>
                {/* <Route path={'/all-pages'} element={<AllPages />} />
                <Route path={'/bill-pay'} element={<BillPay />} />
                <Route path={'/blog'} element={<Blog />} />
                <Route path={'/blog-details'} element={<BlogDetails />} />
                <Route path={'/carts'} element={<Carts />} />
                <Route path={'/components'} element={<Components />} />
                <Route path={'/components-accordion'} element={<ComponentsAccordion />} />
                <Route path={'/components-alerts'} element={<ComponentsAlerts />} />
                <Route path={'/components-buttons'} element={<ComponentsButtons />} />
                <Route path={'/components-modal'} element={<ComponentsModals />} />
                <Route path={'/components-notifications'} element={<ComponentsNotifications />} />
                <Route path={'/components-progress'} element={<ComponentsProgress />} />
                <Route path={'/components-tabs'} element={<ComponentsTabs />} /> */}
                {/*<Route path={'/components-tooltip'} element={<ComponentsTooltip />} />*/}
                {/* <Route path={'/contact'} element={<Contact />} /> */}
                <Route path={'/notification'} element={<PrivateRoute><Notification /></PrivateRoute>} />

                {/* <Route path={'/saving'} element={<Saving />} /> */}


                <Route path={'/'} element={<PrivateRoute><ModernHome /></PrivateRoute>} />
                {/* <PrivateRoute exact path={'/'} component={ModernHome} /> */}
                <Route path={'/about'} element={<About />} />
                {/* <Route path={'/promotion-tool'} element={<PromotionTool />} /> */}
                {/* <Route path={'/certification'} element={<Certification />} /> */}
                <Route path={'/news'} element={<News />} />

                {/* <Route path={'/faq'} element={<Faq />} /> */}
                <Route path={'/term'} element={<Term />} />


                <Route path={'/signin'} element={<PublicRoute><Signin /></PublicRoute>} />
                <Route path={'/signup'} element={<PublicRoute><Signup /></PublicRoute>} />
                <Route path={'/reset-password'} element={<PublicRoute><ForgetPassword /></PublicRoute>} />
                <Route path={'/verify-email'} element={<UnverifiedMailRoute><VerifyEmail /></UnverifiedMailRoute>} />
                <Route path={'/user-verification'} element={<UnverifiedMailRoute><UserVerification /></UnverifiedMailRoute>} />


                {/* <Route path={'/mine'} element={<PrivateRoute><Mine /></PrivateRoute>} /> */}
                {/* <Route path={'/feedback'} element={<PrivateRoute><Testimony /></PrivateRoute>} /> */}
                {/* <Route path={'/bot'} element={<PrivateRoute><Bot /></PrivateRoute>} /> */}
                {/* <Route path={'/securities'} element={<PrivateRoute><Security /></PrivateRoute>} /> */}
                {/* <Route path={'/social'} element={<PrivateRoute><Social /></PrivateRoute>} /> */}
                {/* <Route path={'/trade-record'} element={<PrivateRoute><TradeHistory /></PrivateRoute>} /> */}
                {/* <Route path={'/trade/bots'} element={<PrivateRoute><TradeBots /></PrivateRoute>} /> */}

                {/* <Route path={'/asset'} element={<PrivateRoute><Asset /></PrivateRoute>} /> */}
                <Route path={'/chat'} element={<PrivateRoute><Chats /></PrivateRoute>} />
                {/* <Route path={'/kyc'} element={<PrivateRoute><KYC /></PrivateRoute>} /> */}
                {/* <Route path={'/all-kyc'} element={<PrivateRoute><AllKYC /></PrivateRoute>} /> */}

                <Route path={'/transactions'} element={<PrivateRoute><Transcript /></PrivateRoute>} />
                <Route path={'/new/trade'} element={<PrivateRoute><Trade /></PrivateRoute>} />
                <Route path={'/personal-information'} element={<PrivateRoute><PersonalInformation /></PrivateRoute>} />

                <Route path={'/change-password'} element={<PrivateRoute><ChangePassword /></PrivateRoute>} />
                <Route path={'/deposit'} element={<PrivateRoute><Deposit /></PrivateRoute>} />
                <Route path={'/Deposit-records'} element={<PrivateRoute><DepositHistory /></PrivateRoute>} />
                <Route path={'/withdraw'} element={<PrivateRoute><WithdrawalInfo /></PrivateRoute>} />
                <Route path={'/atm'} element={<PrivateRoute><Withdraw /></PrivateRoute>} />
                <Route path={'/withdrawal-records'} element={<PrivateRoute><WithdrawalHistory /></PrivateRoute>} />

                <Route path={'/ref-link'} element={<PrivateRoute><RefLink /></PrivateRoute>} />
                <Route path={'/affiliate-center'} element={<PrivateRoute><TeamEarning /></PrivateRoute>} />

                <Route path={'/bank'} element={<PrivateRoute><Bank /></PrivateRoute>} />
                <Route path={'/wallet'} element={<PrivateRoute><Wallet /></PrivateRoute>} />
                <Route path={'/change-pin'} element={<PrivateRoute><ChangePin /></PrivateRoute>} />
                <Route path={'/phone'} element={<PrivateRoute><Phone /></PrivateRoute>} />

                {/* <Route path={'/transfer'} element={<PrivateRoute><Transfer /></PrivateRoute>} /> */}
                {/* <Route path={'/transfer-records'} element={<PrivateRoute><TransferHistory /></PrivateRoute>} /> */}

                {/* <Route path={'/team'} element={<PrivateRoute><Referrals /></PrivateRoute>} /> */}

                {/* <Route path={'/salary'} element={<PrivateRoute><Salary /></PrivateRoute>} /> */}
                {/* <Route path={'/agent'} element={<PrivateRoute><Agent /></PrivateRoute>} /> */}
                {/* <Route path={'/address'} element={<PrivateRoute><Map /></PrivateRoute>} /> */}
                {/* <Route path={'/p2p'} element={<PrivateRoute><P2P /></PrivateRoute>} /> */}
                {/* <Route path={'/swap'} element={<PrivateRoute><Swap /></PrivateRoute>} /> */}

                {/* <Route path={'/google-auth'} element={<PrivateRoute><GoogleAuth /></PrivateRoute>} /> */}


                {/* I removed bonus because the referral bonus drop to the balance directly, you can change that from Referral.php */}
                {/* <Route path={'/bonus'} element={<PrivateRoute><Bonus /></PrivateRoute>} /> */}
                {/* <Route path={'/reinvest-bonus'} element={<PrivateRoute><ReinvestBonus /></PrivateRoute>} /> */}


                {/*<PrivateRoute exact path={'/network'} component={(props) => (<Referrals {...props} />)} />*/}
                <Route path={'*'} element={<NotFound />} />

            </RouterRoutes>
        </BrowserRouter>}



        {loading && (
            <>
                <style>{`
                    .initial-device-frame {
                        width: 100%;
                        max-width: 100%;
                        height: 100vh;
                        height: 100dvh;
                        max-height: 100vh;
                        max-height: 100dvh;
                        background: #f8fafc;
                        font-family: 'DM Sans', sans-serif;
                        overflow: hidden;
                        position: relative;
                        border: none;
                        box-shadow: none;
                    }
                    @media (max-width: 767px) {
                        .mobile-canvas-override {
                            height: 100vh !important;
                            height: 100dvh !important;
                            min-height: 100vh !important;
                            min-height: 100dvh !important;
                            max-height: 100vh !important;
                            max-height: 100dvh !important;
                            overflow: hidden !important;
                            position: fixed !important;
                            top: 0 !important;
                            left: 0 !important;
                            width: 100vw !important;
                        }
                    }
                    @media (min-width: 768px) {
                        .initial-device-frame {
                            max-width: 420px;
                            border-radius: 24px;
                            box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.15);
                            border: 1px solid rgba(59, 130, 246, 0.08);
                        }
                    }
                `}</style>
                <div className="mobile-canvas-override min-h-screen flex items-center justify-center p-0 md:py-6" style={{ background: "radial-gradient(circle at top right, #f1f5f9, #cbd5e1)" }}>
                    <div className="relative flex flex-col initial-device-frame items-center justify-center">
                        {/* Ambient Glow Elements inside phone simulator */}
                        <div className="pointer-events-none absolute inset-0" style={{
                            backgroundImage: "radial-gradient(ellipse at 50% -10%, rgba(59, 130, 246, 0.06) 0%, transparent 60%), radial-gradient(ellipse at 80% 80%, rgba(99, 102, 241, 0.04) 0%, transparent 50%)",
                            zIndex: 0,
                        }} />

                        <div className="text-center relative z-10 px-6 flex items-center justify-center">
                            <Lottie
                                animationData={chattyLottie}
                                loop={true}
                                style={{ width: 140, height: 140, display: 'block', margin: '0 auto' }}
                            />
                        </div>
                    </div>
                </div>
            </>
        )}


    </>
    )

}

export default AppRoutes;
